export { Caption1Stronger, caption1StrongerClassNames } from './components/presets/Caption1Stronger/index';
